<template>
  <div class="orderComp">
    <tbl-one-comp :rows="ticket"/>
  </div>
</template>

<script>
export default {
  name: 'orderComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'tickets',
      required: ['id', 'createdAt', 'address', 'kontrollerIdMysql', 'comment', 'isClose', 'rating', 'dealerName', 'dealerIdMysql', 'answer']
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: null })
  },
  components: {
  },
  computed: {
    ticket: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      return this.$helpers.mapper.modelRequired(this.required, model)
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">

.orderComp {
  display: grid;
  grid-template-rows: 116px 1fr 116px;
  grid-template-columns: 1fr;
  width: 100%;
  min-width: 320px;
}
.toolbar {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto;
}
.tool_item {
  height: 36px;
  margin: 40px 32px 40px auto;
}
.btn_close {
  width: 150px;
}

</style>
